import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { style: { width: '100%', height: `auto` } }
const _hoisted_2 = {
  key: 0,
  ref: "fullPage",
  style: {
                width: '100%',
                height: `auto`,
                position: 'absolute',
                left: '-100vw',
                top: '-100vh',
            }
}
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = {
  key: 2,
  class: "text-center"
}
const _hoisted_6 = {
  ref: "a4Ref",
  style: {"z-index":"-1000","width":"210mm","left":"-100%","top":"-100%","position":"absolute","height":"0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_pdf = _resolveComponent("pdf")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.fullPage)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", {
            style: { width: '100%' },
            innerHTML: _ctx.fullPage
          }, null, 8, _hoisted_3)
        ], 512))
      : _createCommentVNode("", true),
    (_ctx.generatedInvoice)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          ref: "htmlWrapper",
          class: "htmlWrapper",
          style: _normalizeStyle({ width: '100%', height: `${this.height}`, maxHeight: `${this.height}` })
        }, [
          _createElementVNode("div", {
            style: { width: '100%' },
            innerHTML: _ctx.generatedInvoice
          }, null, 8, _hoisted_4)
        ], 4))
      : (_openBlock(), _createElementBlock("span", _hoisted_5, "Prévisualisation indisponible")),
    (!_ctx.hideExtraDocument)
      ? _withDirectives((_openBlock(), _createElementBlock("div", { key: _ctx.pdfSrc }, [
          _createElementVNode("div", null, [
            (_ctx.pdfSrc)
              ? (_openBlock(), _createBlock(_component_pdf, {
                  source: _ctx.pdfSrc,
                  key: _ctx.pdfSrc,
                  style: {"width":"100%","margin-top":"12px","box-shadow":"0 0 5px"}
                }, null, 8, ["source"]))
              : _createCommentVNode("", true)
          ])
        ])), [
          [_vShow, _ctx.generatedInvoice && _ctx.pdfSrc && _ctx.invoiceThemeSettings.appendix.includeAppendix]
        ])
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, null, 512)
  ]))
}